import {apiPost, API_URL} from '../api'

export const uploadRecommendApi = async (id: string, rank: number = 1) => {
    return await apiPost(API_URL, `admin/featured_post`, {post_id: id, rank: rank})
}
